module.exports = __webpack_public_path__ + "static/media/reports_image3.0c897a80.webp";